module.exports = __webpack_public_path__ + "img/magento-services-integration_small@2x.a1d235ca.jpg";